import React from "react";
import { format, parse, isValid } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

const FMT = "MM/dd/yyyy";

function toDate(value) {
  if (!value) return undefined;
  const d = parse(value, FMT, new Date());
  if (isValid(d)) return d;
  const alt = new Date(value);
  return isValid(alt) ? alt : undefined;
}

export function DatePicker({ value, onChange, disabled, testid }) {
  const [open, setOpen] = React.useState(false);
  const selected = toDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          disabled={disabled}
          className="flex w-full items-center justify-between rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-left focus:ring-2 focus:ring-teal focus:outline-none disabled:bg-slate-100 disabled:text-slate-400"
        >
          <span className={value ? "text-slate-800" : "text-slate-500"}>
            {value || "Pick a date"}
          </span>
          <CalendarIcon className="h-4 w-4 text-slate-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          captionLayout="dropdown"
          fromYear={1950}
          toYear={new Date().getFullYear() + 1}
          classNames={{ caption_label: "hidden" }}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            onChange(d ? format(d, FMT) : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
